// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-result-popover{background:#fff}.search-result em{text-decoration:none;font-weight:bold}.search-result td{padding:0 !important}.search-result a{padding:.75rem;display:block;color:#000}.search-result a:hover{text-decoration:none;color:#000}.search-result-full em{text-decoration:none;font-weight:bold}.search-result-full a{display:block;color:#000}.search-result-full a:hover{text-decoration:none;color:#000}", ""]);
// Exports
module.exports = exports;
